module.exports = __webpack_public_path__ + "static/img/ID.bee0c3cf.svg";